import React, { useEffect, useState } from "react";
import "./associationBox.scss";
import { Link, useNavigate } from "react-router-dom";

import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { t } from "i18next";
import { isEmpty } from "../../utils/validation";
import {
  deleteFavouriteAssociationWS,
  getFavourtieAssociationsWS,
  getNearAssociationsWS,
  insertFavouriteAssociationWS,
} from "./api/associationBoxAPI";
import { gestioneSnackbar } from "../../utils/common";

const AssociationBox = ({
  title,
  type = 1,
  linkColor,
  data,
  link,
  viewLike = true,
}) => {
  const navigate = useNavigate();

  const [dataList, setDataList] = useState(data);

  useEffect(() => {
    if (isEmpty(data)) {
      if (type == 1) {
        getFavourtieAssociationsWS({ favourite: true }).then((res) => {
          setDataList(res);
        });
      } else {
        getNearAssociationsWS({ limit: 8 }).then((res) => {
          setDataList(res);
        });
      }
    }
  }, []);

  return type === 1 ? (
    <div className="association-box-container-1">
      {/*Tipo 1 association box */}
      {title ? <div className="title">{title}</div> : null}
      <div className="association-box">
        <div className="wrapper-single-association">
          {!isEmpty(dataList)
            ? dataList.map((item, index) => (
                <div
                  className="single-association"
                  key={index}
                  onClick={() => {
                    navigate("/association/" + item.id);
                  }}
                >
                  <img
                    src={
                      item.image
                        ? "data:" + item.image_type + ";base64," + item.image
                        : "/no_img.png"
                    }
                  />
                  <div className="subtitle-img">{item.name}</div>
                </div>
              ))
            : null}
        </div>
        <div
          className="icon-arrow-right"
          onClick={() =>
            navigate(link ? link : "/list-associations?type=follow")
          }
        >
          <span className="lnr lnr-arrow-right"></span>
        </div>
      </div>
    </div>
  ) : (
    <div className="association-box-container-2">
      {/*Tipo 2 association box*/}
      <div className="header-association-container">
        <div className="title">{title}</div>
        <Link
          to={link ? link : "/list-associations"}
          className="view-more-link"
          style={{ color: linkColor ? linkColor : null }}
        >
          {t("common.view_all")}
        </Link>
      </div>
      <div className="association-box">
        {!isEmpty(dataList)
          ? dataList.map((item, index) => (
              <SingleAssociationBox
                key={index}
                id={item.id}
                name={item.name}
                address={item.address}
                image={item.image}
                imageType={item.image_type}
                isFavourite={item.is_favourite}
                viewLike={viewLike}
              />
            ))
          : null}
      </div>
    </div>
  );
};

const SingleAssociationBox = ({
  id,
  name,
  address,
  imageType,
  image,
  isFavourite = false,
  viewLike,
}) => {
  const navigate = useNavigate();
  const [favourite, setFavourite] = useState(false);

  useEffect(() => {
    setFavourite(isFavourite);
  }, []);

  const handleClickFavourite = (id_association) => {
    if (!favourite) {
      insertFavouriteAssociationWS(id_association)
        .then((res) => {
          setFavourite(true);
        })
        .catch((error) => {
          gestioneSnackbar(true, error, "error");
        });
    } else {
      deleteFavouriteAssociationWS(id_association)
        .then((res) => {
          setFavourite(false);
        })
        .catch((error) => {
          gestioneSnackbar(true, error, "error");
        });
    }
  };

  return (
    <div
      className="single-association"
      onClick={() => navigate("/association/" + id)}
    >
      <div className="container-img">
        <img
          src={image ? "data:" + imageType + ";base64," + image : "/no_img.png"}
        />
        {viewLike ? (
          <div className="like-container">
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleClickFavourite(id);
              }}
              style={{ color: "red" }}
            >
              {favourite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
            </div>
          </div>
        ) : null}
      </div>
      <div className="association-name">{name}</div>
      <div className="address-association">{address}</div>
    </div>
  );
};

export default AssociationBox;
